export default {
	Administrador: 'ADM',
	Aspirante: 'ASP',
	Personal: 'PER'
};
